import { t } from 'c-3po';

import * as a from './actions';

// chat class
export const PUBLIC_ACTIONS_LIST = [
    a.EVENT_OPEN_DIALOG,
    a.EVENT_OPEN_ROOM,
    a.EVENT_WINDOW_RESIZE,
    a.EVENT_BESIDA_RERENDER,
    a.EVENT_SET_LOCALE,
];

// Init Positions
export const INIT_POSITION_CABINET = 'positionCabinet';
export const INIT_POSITION_PORTAL = 'positionPortal';

// common
export const RU_LOCALE = 'ru';
export const UK_LOCALE = 'uk';
export const DEFAULT_LOCALE = RU_LOCALE;

export const BESIDA_ACTIVE_CONNECTION = 'active';
export const NOT_INITIALIZED_SOCKET_STATE = 'notInitialized';
export const ORDERS_STORAGE_IDENT = 'ordersStorageIdent';
export const MAX_HISTORY_MSG_LIMITS = 30;
export const URL_PATTERN = new RegExp(`(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|
[-A-Z0-9+&@#/'()%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%'()=~_|$?!:,.]*\)|[A-Z0-9+&@#/%'()=~_|$])`, 'gi');

export const ALL_LANGUAGES = [
    DEFAULT_LOCALE,
    UK_LOCALE
];

// helpers
export const MINUTE_IN_MILISEC = 60000;
export const HOUR_IN_MILISEC = 3600000;
export const CHATS_STORAGE_PREFIX = 'besidaChatSet';
export const CHAT_STORAGE_SETFLAG = 'besidaFaceToFace';
export const CHAT_HISTORY_TODAY = t`Сегодня`;
export const CHAT_HISTORY_YESTERDAY = t`Вчера`;

// auth pages
export const CHAT_AUTH_LOGIN = 'loginPage';
export const CHAT_AUTH_REGISTER = 'registerPage';
export const CHAT_AUTH_SOCIAL = 'socialPage';

// ban pages
export const CHAT_CLIENT_INFO = 'clientInfoPage';
export const CHAT_CLIENT_BAN = 'clientBanPage';
export const CHAT_CLIENT_UNBAN = 'clientUnbanPage';

export const CHAT_COMPANY_INFO = 'companyInfoPage';
export const CHAT_COMPANY_BAN = 'companyBanPage';
export const CHAT_COMPANY_UNBAN = 'companyUnbanPage';

// marks
export const CHAT_AUTO_OPEN_MARK = 'chat_auto_open_mark';
export const CHAT_ROOM_IDENT_MARK = 'room_ident';

// errors
export const ERROR_NETWORK_UNAVAILABLE = 'network_unavailable';

// notifications
export const NOTIFICATION_ERROR_CLIENT_INFO = 'notificationErrorGetClient';
export const NOTIFICATION_ERROR_COMPANY_INFO = 'notificationErrorGetCompany';

// action hash
export const ACTION_HASH_CLIENT_OPINION = 'hashClientOpinion';
export const ACTION_HASH_CLIENT_COMMENT = 'hashClientComment';

// action listeners
export const INIT_ACTION_LISTENERS = 'init';
export const UPDATE_ACTION_LISTENERS = 'update';
export const OPEN_DIALOG_ACTION_LISTENERS = 'openDialog';

// analytics
export const ANALCS_MAIN_CATEGORY = 'desktop_chat';
export const ANALCS_PAGE_PRODUCT_CARD = 'product_ cart';
export const ANALCS_PAGE_PRODUCT_LIST = 'product_list';
export const ANALCS_PAGE_CATEGORY_LIST = 'category_list';
export const ANALCS_PAGE_OPINIONS_LIST = 'opinions_list';
export const ANALCS_PAGE_CLASSIFIED_ADD = 'classified_add';
export const ANALCS_PAGE_HOME = 'main';
export const ANALCS_PAGE_CABINET = 'cabinet';

export const ANALCS_ACTION_BACK_TO_CHATS = 'back';
export const ANALCS_ACTION_START_CHAT = 'chat';
export const ANALCS_ACTION_START_BUY_BUTTON = 'start_button';
export const ANALCS_ACTION_START_LINK = 'start_link';
export const ANALCS_ACTION_CLOSE_CHAT = 'close';
export const ANALCS_ACTION_VIEW_PRODUCT = 'view_product';
export const ANALCS_ACTION_CREATE_ORDER = 'create_order';
export const ANALCS_ACTION_SEND_SUCCESS = 'send_success';
export const ANALCS_ACTION_CUSTOMER_MSG = 'customer_message';
export const ANALCS_ACTION_REGISTER_FB = 'registration_facebook';
export const ANALCS_ACTION_REGISTER_VK = 'registration_vk';
export const ANALCS_ACTION_REGISTER_OD = 'registration_ok';
export const ANALCS_ACTION_REGISTER_GM = 'registration_gm';
export const ANALCS_ACTION_REGISTER_START = 'registration_start';
export const ANALCS_ACTION_REGISTER_FINISH = 'registration_finish';
export const ANALCS_ACTION_AUTHORIZATION = 'authorization';
export const ANALCS_ACTION_REGISTER_BACK = 'back_registration';
export const ANALCS_ACTION_AUTH_SUCCESS = 'send_authorization_success';
export const ANALCS_ACTION_PASS_REMIND = 'authorization_password';

// size
export const SIZE_DIALOG_CONTEXT_OFFSET = 70;
export const SIZE_DIALOG_CONTEXT_MAGIC = 30;
export const SIZE_DIALOG_INPUT_HEIGHT = 105;
export const SIZE_DIALOG_HEIGHT_WITH_CNTXT = 741;
export const SIZE_DIALOG_HEIGHT = 781;

export const SIZE_OPTIMAL_WINDOW_HEIGHT = 960;

// coefficients
export const COEFFICIENT_CHAT_BODY_DEFAULT = 1;
export const COEFFICIENT_CHAT_BODY_MINIMAL = 0.4;

// event delays
export const DIALOG_UNREAD_MARK_DELAY = 1500;
export const DIALOG_SCROLL_EVENT_THROTTLE = 100;
export const DIALOG_DEFAULT_UNBLOCK_INPUT_DELAY = 3000;
export const DIALOG_WORD_UNBLOCK_INPUT_DELAY = 3000;

export const CHAT_APPEAR_TIMEOUT = 300;
export const CHAT_ENTER_TIMEOUT = 300;
export const CHAT_LEAVE_TIMEOUT = 300;

export const RESIZE_EVENT_DEBOUNCE_DELAY = 200;

export const BESIDA_RERENDER_INTERVAL = 10000;

// keycodes
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_UP = 38;
export const KEY_CODE_ESCAPE = 27;

// QA flags
export const QA_LAZY_LOAD_FOR_SCROLL = 'QALazyLoadScrollEvent';


// Company types
export const COMPANY_B2C_TYPE = 0;
export const COMPANY_C2C_TYPE = 1;